import { _ } from "../../../../core/polyglot/polyglot.js";
import AbstractPeriodReportEvent from "./AbstractPeriodReportEvent.js";

/**
 * A `NotifyEvent` is logged each time a period report email notification is sent
 * by an accountant.
 */
export default class NotifyEvent extends AbstractPeriodReportEvent {
	getLabel() {
		return _("Notified");
	}

	static getType() {
		return "Notify";
	}
}
